<!-- section start -->

<section class="section-b-space" *ngIf="product">
  <div class="collection-wrapper">
   
    <div class="container">
      <div class="row">   
          <div class="col-lg-12">
            <mat-card class="margin-card">
              <h3 class="title-invoice">{{ 'product' | translate  }}</h3>
          <div class="container-fluid">
            <div class="row" >
              <div class="col-lg-6">
                <ngx-slick-carousel class="product-slick" #slickModal="slick-carousel" [config]="slideConfig" >
                  <div ngxSlickItem *ngFor="let image of getPhotosArray(product.photos)">
                    <div class="flex-container-photo-detail">
                      <div class="flex-row-photo-detail">
                        <img [src]="geturl(image)" alt="" class="img-fluid">
                      </div>
                    </div>
                  </div>
                </ngx-slick-carousel>
                <div class="row" *ngIf="getPhotosArray(product.photos).length > 1">
                  <div class="col-12 p-0">
                    <ngx-slick-carousel class="slider-nav" #slickModal="slick-carousel" [config]="slideNavConfig">
                      <div ngxSlickItem *ngFor="let image of getPhotosArray(product.photos)">
                        <div>
                          <img [src]="geturl(image)" alt="" class="img-fluid">
                        </div>
                      </div>
                    </ngx-slick-carousel>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 rtl-text">
                <div class="product-right">
                  <h2 class="card-title">{{product.name}}</h2> 
                  <p class="card-text">{{product.description}}</p>               
                  <h3 *ngIf="validatePrice(product)" >{{ getPrice(product) | currency:productsService?.currency:'symbol'}}</h3>                           
                  <div class="row">
                    <div class="col-md-12 product-buttons">
                      <button mat-stroked-button color="primary" [routerLink]="'/home/articles'">{{'back'| translate}}</button> 
                      <button mat-raised-button color="primary" *ngIf="validatePrice(product)" (click)="addToCart(product, counter)">{{'cart-add'| translate}}</button>
                          
                    </div>                    
                  </div>                                    
                </div>
              </div>
            </div>
          </div>
        </mat-card>
          </div>
        </div>
      </div>
    </div>
</section>

<!-- Section ends -->

